import Trainers from '@/containers/trainer/Index';
import Create from '@/containers/trainer/Create';
import View from '@/containers/trainer/View';
import UnboundView from '@/containers/trainer/UnboundView';
import BoundView from '@/containers/trainer/BoundView';
import Nickname from '@/containers/trainer/Nickname';

import {
    ROUTE_TRAINER_LIST,
    ROUTE_TRAINER_VIEW,
    ROUTE_TRAINER_CREATE,
    ROUTE_TRAINER_NICKNAME,
    ROUTE_TRAINER_VIEW_UNBOUND,
    ROUTE_TRAINER_VIEW_BOUND,
} from './names';


export default [
    {
        path: '/trainers',
        name: ROUTE_TRAINER_LIST,
        component: Trainers,
        meta: {
            auth: true,
            title: '会员列表',
        },
    },
    {
        path: '/trainer/create',
        name: ROUTE_TRAINER_CREATE,
        component: Create,
        meta: {
            auth: true,
            title: '新增会员',
        },
    },
    {
        path: '/trainer/:id(\\d+)',
        name: ROUTE_TRAINER_VIEW,
        component: View,
        meta: {
            auth: true,
            title: '会员',
            bridge: true,
        },
    },
    {
        path: '/trainer/:id(\\d+)/unbound',
        name: ROUTE_TRAINER_VIEW_UNBOUND,
        component: UnboundView,
        meta: {
            auth: true,
            title: '会员',
        },
    },
    {
        path: '/trainer/:id(\\d+)/bound',
        name: ROUTE_TRAINER_VIEW_BOUND,
        component: BoundView,
        meta: {
            auth: true,
            title: '会员',
        },
    },
    {
        path: '/trainer/:id(\\d+)/nickname',
        name: ROUTE_TRAINER_NICKNAME,
        component: Nickname,
        meta: {
            auth: true,
            title: '会员',
        },
    },
];



// WEBPACK FOOTER //
// ./src/router/trainer.js